import BigNumber from 'bignumber.js'

BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80,
})

export const BOW_PER_BLOCK = new BigNumber(0.2)
export const SECONDS_PER_YEAR = new BigNumber(60 * 60 * 24 * 365)
// MasterChef.updatePool pays stakers 7479/10000 of a pool's emission; the rest goes to the dev and NFT wallets
export const MASTERCHEF_STAKER_SHARE = new BigNumber(7479).div(10000)
// Part of the 0.25% swap fee that stays in the pool for LPs (the other 0.13% goes to the referral and treasury wallets)
export const LP_FEE_SHARE = 0.0012
export const VAULTS_DISTRIBUTION_PERCENTAGE = 0.995
export const BASE_URL = 'https://toonswap.xyz'
export const BASE_EXCHANGE_URL = 'https://toonswap.xyz/'
export const BASE_ADD_LIQUIDITY_URL = `${BASE_EXCHANGE_URL}add`
export const BASE_LIQUIDITY_POOL_URL = `${BASE_EXCHANGE_URL}pool`
export const LOTTERY_MAX_NUMBER_OF_TICKETS = 50
export const LOTTERY_TICKET_PRICE = 1
export const START_TIMESTAMP = 1678807800
export const BACK_DOMAIN = 'https://toonswap-frontend.netlify.app'
// The phishing warning banner is hidden for now; set this to true to show it again.
export const SHOW_PHISHING_BANNER = false
